export class YodleeConfig {
  fastlinkUrl = '';
  secureUploaderServiceUrl = '';
}
